import { render, staticRenderFns } from "./ad-top-edit.vue?vue&type=template&id=ecf13ba2&scoped=true&"
import script from "./ad-top-edit.vue?vue&type=script&lang=js&"
export * from "./ad-top-edit.vue?vue&type=script&lang=js&"
import style0 from "./ad-top-edit.vue?vue&type=style&index=0&id=ecf13ba2&scoped=true&lang=scss&"
import style1 from "./ad-top-edit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf13ba2",
  null
  
)

export default component.exports